import React from "react";


import {Title} from "react-admin"
import {Timeline} from "cms-toolbox";


export const TimelineList = (props)=><React.Fragment><Title title="Timeline" /><Timeline {...props}/></React.Fragment>
